import Axpi from '../axpi'

const urlPrefix = 'dynamics/sorority-wars/tailors'

const tailorsAPI = {
  getAll () {
    return Axpi.$http().get(urlPrefix)
  },
  getOne (tailorId) {
    return Axpi.$http().get(`${urlPrefix}/${tailorId}`)
  },
  getParts (tailorId) {
    return Axpi.$http().get(`${urlPrefix}/${tailorId}/parts`)
  },
  claim (tailorId) {
    return Axpi.$http().post(`${urlPrefix}/${tailorId}/claim`, {})
  }
}

export default tailorsAPI
